import {useNavigate, useParams} from "react-router-dom";
import HeaderAIChatbot from '~/components/Layout/components/HeaderAIChatbot';
import React, {Fragment, useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPaperPlane, faMicrophone, faEllipsis, faPen, faTrash, faEdit, faMicrophoneLines} from "@fortawesome/free-solid-svg-icons";
import styles from './AIChatbot.module.scss';
import classNames from "classnames/bind";
import {useEffect, useState} from "react";
import AwsChatbotAPI from '~/api/awsChatbotApi';
import {CenteredModal, TypeWriterText, TypingIndicator} from '~/components';
import {usePlanFeature} from '~/pages/context/PlanFeatureContext';
import {ArrowLeftToLine, ArrowRightToLine, Copy, Volume2Icon, ThumbsUp, ThumbsDown, Repeat, PauseCircle} from "lucide-react";
import {RotatingLines} from "react-loader-spinner";
import {toast} from "react-toastify";
import {RecognizeTextAsync, SynthesizeSpeechAsync} from "~/aws/lexClient";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import {
    getCurrentAudioState,
    setCurrentAudio,
    clearCurrentAudio,
    isAudioPlaying
} from "~/utils/AudioManager";
import useAudioAutoStopRecorder from "./hooks/useAudioAutoStopRecorder";
import WaveformCanvas from './component/WaveformCanvas';
import UpgradePlanRequest from './component/UpgradePlanRequest';
import awsChatbotApi from "~/api/awsChatbotApi";
import {text} from "framer-motion/m";
const cx = classNames.bind(styles);
function AIChatbot(){
    const { id } = useParams();
    const [newChat, setNewChat] = useState(false);
    const [sessionsChat, setSessionsChat] = useState([]);
    const [sessionId, setSessionId] = useState(id);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [sessionTitle, setSessionTitle] = useState("");
    const [sessionTitleInput, setSessionTitleInput] = useState("");
    const [collapse, setCollapse] = useState(false);
    const [activeMessageId, setActiveMessageId] = useState(-1);
    const [isSending, setIsSending] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [currentCountChat, setCurrentCountChat] = useState(0);
    const [showModalUpgradePlan, setShowModalUpgradePlan] = useState(false);
    const [upgradePlanId, setUpgradePlanId] = useState(0);
    const [showModalRecording, setShowModalRecording] = useState(false);
    const [toggleAudio, setToggleAudio] = useState(null);
    const [loadingAudio, setLoadingAudio] = useState(null);
    const [countChatLimit, setCountChatLimit] = useState(0);
    const textareaRef = useRef(null);
    const chatEndRef = useRef(null);
    const navigate = useNavigate();
    const {planFeature} = usePlanFeature();
    const chatQuestionsDefault = [
        "What is love?",
        "What is success?",
        "How can you gain long-life success, health, and happiness?",
        "How can I stay healthy?",
        "What is pseudo-success?"
    ];

    const { startRecording, recording } = useAudioAutoStopRecorder(2000, 5, (audioBlob) => {
        setShowModalRecording(false);
        if(audioBlob){
             const formData = new FormData();
             formData.append("file", audioBlob, "record.mp3");
             AwsChatbotAPI.speechToTextAsync(formData)
                 .then(async (res) => {
                     if (res.data.Message){
                         await handleMessageInput(res.data.Message, false);
                     }
                 })
        }
    });

    useEffect(() => {
        AwsChatbotAPI.getUserCountChat()
            .then((res) => {
                setCurrentCountChat(res.data.CurrentChatCount);
                setCountChatLimit(res.data.CountLimit);
            })
            .catch((err) => {
                
            })
    }, [])


    useEffect(() => {
        AwsChatbotAPI.getChatSessionByUserId()
            .then((res) => {
                const grouped = _.groupBy(res.data, "Classifications");
                setSessionsChat(grouped);
            })
            .catch((err) => {
                ;
            });
    }, [sessionTitle]);

    useEffect(() => {
        const { currentAudioId, currentAudioRef } = getCurrentAudioState();
        if (currentAudioId !== null) {
            clearCurrentAudio();
        }
        if(sessionId && !newChat){
            const params = new URLSearchParams({
                userId: "0",
                sessionId: sessionId,
            });
            AwsChatbotAPI.getChatHistoryBySessionId(params)
                .then((res) => {
                    const parsedData = res.data.map(item => ({
                        ...item,
                        ShowButtons: true,
                        ChatButtons:
                            item.ChatButtons && item.ChatButtons.startsWith("[")
                                ? JSON.parse(item.ChatButtons)
                                : []
                    }));
                    setMessages(parsedData);
                    if(res.data.length <= 0){
                        navigate('/ai-chatbot/chat', { replace: true });
                    }
                })
                .catch((err) => {
                    ;
                });
        }
        else {
            if(newChat){
                setNewChat(false);
            }
            setMessages([])
        }

    }, [sessionId]);


    const handleInput = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto"; // reset
            textarea.style.height = Math.min(textarea.scrollHeight, 130) + "px";
        }
    };

    const handleMessageInput = async (message, isMessageInput) => {
        if(currentCountChat >= countChatLimit){
            setUpgradePlanId(1);
            setShowModalUpgradePlan(true);
            return;
        }
        if (isTyping) {
            return;
        }
        setIsTyping(true);
        const trimmed = message.trim();
        if (!trimmed) return;
        let newSessionId = '';
        if(messages.length <= 0){
            setNewChat(true);
            newSessionId = uuidv4();
            setSessionId(newSessionId);
            window.history.pushState({}, "", `/ai-chatbot/chat/${newSessionId}`);
            const data = {
                SessionId: newSessionId,
                Title: message.substring(0, 100)
            }
            await AwsChatbotAPI.insChatSessionTitle(data);
            setSessionTitle(message.substring(0, 100));
        }

        setMessages((prev) => [
            ...prev,
            { ChatTypeId: 1, ChatContent: trimmed },
        ]);
        const dataInsert = {
            SessionId: newSessionId === '' ? sessionId : newSessionId,
            ChatContent: trimmed,
            ChatTypeId: 1,
        }
        AwsChatbotAPI.inCreaseUserCountChat();
        AwsChatbotAPI.insAwsChatHistory(dataInsert);
        setCurrentCountChat(prev => prev + 1);
        if(isMessageInput){
            setMessageInput("");
        }
        await handleRecognizeTextAsync(trimmed, newSessionId === '' ? sessionId : newSessionId);
    }

    const handleSendMessage = async () => {
        await handleMessageInput(messageInput, true);
    }

    const handleRecognizeTextAsync = async (textInput, currentSessionId) => {
        if (textInput === "") return;
        setIsSending(true);
        const currentLanguage = await AwsChatbotAPI.languageDetectedAsync({TextInput: textInput});
        if(!planFeature.SupportedLanguages && currentLanguage.data.Language !== "English"){
            setUpgradePlanId(3);
            setShowModalUpgradePlan(true);
            setIsSending(false);
            setIsTyping(false);
            return;
        }

        let chatContent = "";
        let newButtons = [];

        if (currentLanguage.data.Language === 'unknown' || currentLanguage.data.Language === "" || currentLanguage.data.IsRandomText){
            chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
            newButtons = [];
        }
        else
        {
            const res = await RecognizeTextAsync( currentLanguage.data.Language !== "English" ? currentLanguage.data.EnglishTranslate : textInput, currentSessionId);
            if(res.success){
                chatContent = res.data.messages[0].content;
                let chatButtons = res.data.messages[1].imageResponseCard.buttons;
                newButtons = chatButtons.map(item => ({
                    Text: item.text,
                    Value: item.value
                }));

                if(currentLanguage.data.Language !== "English"){
                    const payLoad = {
                        Message: res.data.messages[0].content,
                        Buttons: chatButtons
                    }
                    const resTranslate = await awsChatbotApi.translateLanguageAsync({
                        TextInput: JSON.stringify(payLoad),
                        Language: currentLanguage.data.Language
                    })
                    if( typeof(resTranslate.data) === "string") {
                        resTranslate.data = JSON.parse(resTranslate.data.slice(
                            resTranslate.data.indexOf('{'),
                            resTranslate.data.lastIndexOf('}') + 1
                        ));
                    }

                    chatContent = resTranslate.data.Message;
                    chatButtons = resTranslate.data.Buttons;
                    newButtons = chatButtons.map(item => ({
                        Text: item.text,
                        Value: item.value
                    }));
                }
            }
            else
            {
                chatContent = "Looks like you might have typed something by mistake! How can I help you today?";
                newButtons = [];
            }
        }

        setIsSending(false);
        setMessages((prev) => [
            ...prev,
            {
                ChatTypeId: 2,
                ChatContent: chatContent,
                ChatButtons: newButtons,
                IsNew: true,
                ShowButtons: false,
            },
        ]);
        const data = {
            SessionId: currentSessionId,
            ChatContent: chatContent,
            ChatTypeId: 2,
            ChatButtons: JSON.stringify(newButtons)
        }
        AwsChatbotAPI.insAwsChatHistory(data)
    }

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth", block: 'end' });
    }, [messages]);

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            await handleSendMessage();
        }
    };

    const handleChatButton = async (buttonValue, buttonText) => {
        await handleMessageInput(buttonText, false);
    };

    const handleConfirmDelete = () => {

    }

    const handleConfirmEdit = () => {
        if(sessionTitleInput.trim() === "") return;

        const data = {
            SessionId: sessionId,
            Title: sessionTitleInput.trim()
        }
        AwsChatbotAPI.updChatSessionTitle(data)
            .then((res) => {
                setSessionTitle(sessionTitleInput.trim());
                toast.success(<span className="fs-9 fw-bold">Title has been updated.</span>);
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating title.</span>)
                ;
            })
            .finally(() => {
                setShowModalEdit(false);
            })
        ;
    }

    const handleNewChatSession = () => {
        setSessionId("");
        navigate('/ai-chatbot/chat', { replace: true });
    }

    const handleToggleCollapse = () => {
        const html = document.documentElement; // <html>
        html.classList.toggle("navbar-vertical-collapsed");
        setCollapse(prev => !prev);
    }

    const handleMessageClick = (index) => {
        if(isTyping) return;
        if(activeMessageId === index || window.innerWidth <= 768) return;
        setActiveMessageId(index);
    }

    const handleMouseEnter = (index) => {
        if(isTyping) return;
        if(window.innerWidth > 768){
            setActiveMessageId(index);
        }
    }
    const handleMouseLeave = () => {
        if(isTyping) return;
        if(window.innerWidth > 768){
             setActiveMessageId(null);
             setToggleAudio(null);
        }
    }

    const handleCopyMessage = (messageContent) => {
        navigator.clipboard.writeText(messageContent)
            .then(() => {
            })
            .catch(err => {
                ;
            });
    };

    const handleTextToSpeech = (messageContent, messageId) => {
        if(!planFeature.VoiceChat){
            setUpgradePlanId(2);
            setShowModalUpgradePlan(true);
            return;
        }
        const { currentAudioId, currentAudioRef } = getCurrentAudioState();
        if (currentAudioId === messageId) {
            setToggleAudio(prev => !prev);
            if (currentAudioRef.paused) {
                currentAudioRef.play();
            } else {
                currentAudioRef.pause();
            }
            return;
        }

        if (currentAudioId !== null) {
            setLoadingAudio(null);
            clearCurrentAudio();
        }
        setLoadingAudio(true)
        AwsChatbotAPI.textToSpeechAsync({TextInput: messageContent})
            .then(async (res) => {
                const blob = new Blob([res.data], { type: "audio/mpeg" });
                const newUrl = URL.createObjectURL(blob);
                const audio = new Audio(newUrl);
                audio.controls = true;
                audio.autoplay = true;
                setCurrentAudio(messageId, audio, newUrl);
                setToggleAudio(true);
                setLoadingAudio(null);
                audio.play();
                audio.onended = () => {
                    setToggleAudio(prev => !prev);
                };
            })
            .catch(err => {
                setLoadingAudio(false);
                toast.error(<span className="fs-9 fw-bold">An error occurred while playing audio.</span>)
                ;
            })
    }

    const handleVoiceChat = () => {
        if(!planFeature.VoiceChat){
            setUpgradePlanId(2);
            setShowModalUpgradePlan(true);
            return;
        }
        setShowModalRecording(true);
        startRecording();
    }

    const handleRepeatMessage = (messageContent) => {
        setMessageInput(messageContent);
    }

    const updateMessageAtIndex = (index, updates) => {
        setMessages((prev) =>
            prev.map((msg, i) => (i === index ? { ...msg, ...updates } : msg))
        );
    };

    const renderMessage = (message, index) => {
        if (message.ChatTypeId === 1) {
            return (
                <div key={index} className="d-flex chat-message flex-column align-items-end pb-4"
                     onMouseEnter={() => handleMouseEnter(index)}
                     onMouseLeave={() => handleMouseLeave(index)}
                >
                    <div className={cx("right-message", "chat-message-content", "fs-8-1", "border")}>
                        {message.ChatContent}
                    </div>
                    {
                        activeMessageId === index && (
                            <div className='cursor-pointer my-1'>
                                <Copy size={14} className="me-3"
                                      onClick={() => handleCopyMessage(message.ChatContent)}
                                />
                                <Repeat size={14} className="me-3"
                                        onClick={() => handleRepeatMessage(message.ChatContent)}
                                />
                            </div>
                        )
                    }
                </div>
            );
        }

        return (
            <div key={index} className="d-flex chat-message pb-4 flex-column"
                 onMouseEnter={() => handleMouseEnter(index)}
                 onMouseLeave={() => handleMouseLeave(index)}
            >
                <div className={cx("chat-message-content", "fs-8-1")}>
                    {message.IsNew ? (
                        <TypeWriterText
                            text={message.ChatContent}
                            onComplete={() => {
                                updateMessageAtIndex(index, {
                                    IsNew: false,
                                    ShowButtons: true
                                })
                                setIsTyping(false)
                            }}
                        />
                    ) : (
                        message.ChatContent
                    )}
                </div>

                {
                    message.ShowButtons && message.ChatButtons && (
                        <div className={cx("chat-buttons", "d-flex mt-2 mb-2")}>
                            {message.ChatButtons.map((button, idx) => (
                                <div
                                    key={idx}
                                    title={button.Text}
                                    className={cx("chat-button", "fs-8-1 border", "cursor-pointer")}
                                    onClick={() => handleChatButton(button.Value, button.Text)}
                                >
                                <span className={cx("button-text", "fs-9", "fw-bold")}>
                                  {button.Text}
                                </span>
                                </div>
                            ))}
                        </div>
                    )
                }

                {
                    (activeMessageId === index || toggleAudio) && (
                        <div className='cursor-pointer my-1 d-flex'>
                            <Copy size={14} className="me-3" onClick={() => handleCopyMessage(message.ChatContent)}/>
                            {isAudioPlaying(index) ? (
                                <PauseCircle
                                    size={14}
                                    className="me-3"
                                    onClick={() => handleTextToSpeech(message.ChatContent, index)}
                                />
                            ) : loadingAudio ? (
                                <RotatingLines
                                    height="16"
                                    width="16"
                                    color="grey"
                                    wrapperClass='me-3'
                                    animationDuration="1.7"
                                    strokeWidth="4"
                                    ariaLabel="rotating-lines-loading"
                                />
                            ) : (
                                <Volume2Icon
                                    size={14}
                                    className="me-3"
                                    onClick={() => handleTextToSpeech(message.ChatContent, index)}
                                />
                            )}
                            <ThumbsUp size={14} className="me-3"/>
                            <ThumbsDown size={14} className="me-3"/>
                        </div>
                    )
                }
            </div>
        );
    };

    if(planFeature.CurrentServicePlanId === 0)
    {
        navigate('/auth/locked-screen', { replace: true });
    }

    return (
        <Fragment>
            {
                planFeature.CurrentServicePlanId > 0 &&
                <Fragment>
                    <nav className="navbar navbar-vertical navbar-expand-lg">
                        <div className='navbar-collapse collapse' id='navbarVerticalCollapse'>
                            {
                                !collapse && (
                                    <div className={`navbar-vertical-content`}>
                                        <ul className="navbar-nav flex-column" id='navbarVerticalNav'>
                                            <li className='nav-item'>
                                                <div className="nav-item-wrapper">
                                                    <div
                                                        className="nav-link ps-2 pt-2 pb-2 d-flex align-items-center justify-content-between cursor-pointer mb-1"
                                                        style={{border: "1px solid #eff2f6"}}
                                                        onClick={handleNewChatSession}>
                                                        <div>
                                                            <FontAwesomeIcon icon={faEdit} className="fs-8 me-2"/>
                                                            <span className="pt-1 fs-8-1">New Chat</span>
                                                        </div>
                                                        <span className="pt-1 float-end fs-9" style={{color: "#cdcdcd"}}>Ctrl + Shift + O</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className='nav-item'>
                                                {Object.keys(sessionsChat).map((classification) => (
                                                    <div key={classification}>
                                                        <p className="navbar-vertical-label">{classification}</p>
                                                        <hr className="navbar-vertical-line"/>
                                                        {
                                                            sessionsChat[classification].map((session) => (
                                                                <div key={session.AwsChatSessionId}
                                                                     className={cx(`${session.SessionId === sessionId ? 'active-session' : ""}`, `nav-link ps-2 pt-1 pb-1 d-flex align-items-center cursor-pointer mb-1`)}
                                                                     onClick={() => {
                                                                         setSessionId(session.SessionId);
                                                                         window.history.pushState({}, "", `/ai-chatbot/chat/${session.SessionId}`);
                                                                     }}>
                                                                    <span
                                                                        className={cx("session-title")}>{session.Title}</span>
                                                                    <div className={cx("dropdown", "session-title-action")}>
                                                                        <button
                                                                            className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none"
                                                                            type="button" data-bs-toggle="dropdown"
                                                                            data-boundary="window" aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            data-bs-reference="parent">
                                                                            <FontAwesomeIcon icon={faEllipsis}
                                                                                             className='me-1'/>
                                                                        </button>
                                                                        <div
                                                                            className={cx("dropdown-menu-action", "dropdown-menu", "dropdown-menu-end", "py-2")}>
                                                                            <span className="dropdown-item"
                                                                                  onClick={() => {
                                                                                      setShowModalEdit(true);
                                                                                      setSessionTitleInput(session.Title);
                                                                                  }}
                                                                            >
                                                                                Edit
                                                                                <FontAwesomeIcon icon={faPen}
                                                                                                 className='float-end'/>
                                                                            </span>
                                                                            <span className="dropdown-item"
                                                                                  onClick={() => setShowModalDelete(true)}>
                                                                                Delete
                                                                                <FontAwesomeIcon icon={faTrash}
                                                                                                 className='float-end'/>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                ))}
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </div>
                        <div className="navbar-vertical-footer">
                            <button onClick={handleToggleCollapse}
                                    className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center">
                                <ArrowLeftToLine size={19}/>
                                <ArrowRightToLine size={19}/>
                                <span className="navbar-vertical-footer-text ms-2">Collapsed</span>
                            </button>
                        </div>
                    </nav>
                    <HeaderAIChatbot/>
                    <div className={cx('chat-container', 'content pe-3 ps-3')}>
                        <div className={cx('chat-container__body', 'scrollbar')}>
                            <div className={cx('chat-content')} ref={chatEndRef}>
                                {
                                    messages.length > 0 ?
                                        (
                                            <Fragment>
                                                {messages.map((message, index) => renderMessage(message, index))}
                                                {isSending && (
                                                    <div className="d-flex chat-message pb-4 flex-column">
                                                        <div className={cx("chat-message-content", "fs-8-1")}>
                                                            <TypingIndicator/>
                                                        </div>
                                                    </div>
                                                )}
                                                <div style={{height: "150px"}}></div>
                                            </Fragment>
                                        )
                                        :
                                        (
                                            <div style={{marginTop: "30vh"}}>
                                                <h4 className="mb-3 text-center">What can I help with?</h4>
                                                <div className="d-flex justify-content-center">
                                                    <div
                                                        className={cx("chat-buttons", "d-flex mt-2 mb-2 justify-content-center")}>
                                                        {chatQuestionsDefault.map((question, index) => (
                                                            <div
                                                                key={index}
                                                                title={question}
                                                                className={cx("chat-button", "fs-8-1 cursor-pointer border")}
                                                                onClick={() => handleChatButton(question, question)}
                                                            >
                                                                <span className={cx("button-text", "fs-9 fw-bold")}>
                                                                  {question}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                        <div className={cx('chat-footer', 'w-100')}>
                            <div className={cx('chat-textarea-container', 'bg-body-emphasis')}>
                        <textarea ref={textareaRef} onInput={handleInput} placeholder="Type message here..."
                                  className={cx('chat-textarea', 'fs-8-1 ps-2 scrollbar')}
                                  value={messageInput} onChange={(e) => setMessageInput(e.target.value)}
                                  onKeyDown={handleKeyDown}/>
                                <div className='d-flex justify-content-end'>
                                    <div className={cx('icon-action')} onClick={handleVoiceChat}>
                                        <FontAwesomeIcon className="fs-9" icon={faMicrophone}/>
                                    </div>
                                    <div className={cx('icon-action', 'me-3')} onClick={handleSendMessage}>
                                        <FontAwesomeIcon className="fs-9" icon={faPaperPlane}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CenteredModal show={showModalDelete} title="Delete chat" onClose={() => setShowModalDelete(false)}
                                   confirmText="Delete" onConfirm={handleConfirmDelete}>
                        <span className="fs-9 fw-bold">Are you sure you want to remove this chat?</span>
                    </CenteredModal>

                    <CenteredModal show={showModalEdit} title="Edit chat title" onClose={() => setShowModalEdit(false)}
                                   confirmText="Save Changes" onConfirm={handleConfirmEdit}>
                        <div className="form-icon-container">
                            <div className="form-floating">
                                <input value={sessionTitleInput} className="form-control form-icon-input"
                                       id="emailSocial" type="email" placeholder="Email"
                                       onChange={(e) => setSessionTitleInput(e.target.value)}/>
                                <label className="text-body-tertiary form-icon-label" htmlFor="emailSocial">ENTER NEW
                                    TITLE</label>
                            </div>
                            <FontAwesomeIcon icon={faPen} className='form-icon fs-9 text-body'/>
                        </div>
                    </CenteredModal>

                    <UpgradePlanRequest typeId={upgradePlanId} setShowModal={setShowModalUpgradePlan} showModal={showModalUpgradePlan}/>

                    <CenteredModal
                        show={showModalRecording}
                        title=""
                        onClose={() => setShowModalRecording(false)}
                        closeText=""
                    >
                        <div className="text-center">
                            <FontAwesomeIcon icon={faMicrophoneLines} className="fs-3 text-primary"/>
                            <p className="fs-8-1 mt-1">Recoding...</p>
                            <WaveformCanvas />
                        </div>
                    </CenteredModal>
                </Fragment>
            }
        </Fragment>
    )
}

export default AIChatbot
